<template>
  <v-app-bar app clipped-left color="primary" >
    <span @click="home"
      class="pl-2 mr-2 font-weight-light pointer"
      style="color: white; font-size: 25px;"
      > <span><v-icon color="white">mdi-book-open-page-variant-outline</v-icon></span>
      taleem<span class="font-weight-black black--text">.app</span>
    </span>

    <v-app-bar-nav-icon v-if="currentUser.userType !== 'teacher'" @click.stop="drawerToggle" />

    <v-toolbar-title class="mr-12 align-center" v-if="currentUser.userType !== 'teacher'">
      <span class="title white--text text-capitalize">{{ currentBusiness.name }}</span>
      
    </v-toolbar-title>
    <!-- <v-col cols="3"  v-if="$vuetify.breakpoint.smAndUp">
      <AutoComplete v-model="selectedCustomer" />
    </v-col> -->

    <v-spacer />
    <UserMenu />
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import Notifications from "./Notifications";
// import customerService from "@/modules/Customer/service.js";
// import AutoComplete from "@/modules/Customer/components/AutoComplete"
import UserMenu from "./Menu";
export default {
  data() {
    return {
      Customer: [],
      selectedCustomer: null,
      loading: false,
      customerSearch: null,
    };
  },
  watch: {
    selectedCustomer(val) {
      if (val) {
        this.$router.push({ path: `/customer/${val.id}/profile` });
      }
    }
  },
  components: {
    // AutoComplete,
    UserMenu,
  },
  created() {
    // this.getCustomerList();
    console.log('currentBusiness', this.currentBusiness)
    console.log('currentUser', this.currentUser)
  },
  computed: {
    ...mapGetters("global", ["currentBusiness", "currentUser"])
  },
  methods: {
    ...mapActions("teacherLayout", ["drawerToggle"]),
    home() {
      // console.log('this', this.$route.name)
      if (this.$route.name !== 'thome') {
        this.$router.push({path: '/t'})
      }
      
    },
    // getCustomerList() {
    //   this.loading = true;
    //   return customerService.getAll().then(response => {
    //     this.loading = false;
    //     this.Customer = response.data;
    //     return response;
    //   });
    // }
  }
};
</script>
